module.exports = __webpack_public_path__ + "img/bg_4_1.fe70eef6.jpg";